import React from 'react';

const logos = [
    { image: require('./../../images/home-11/client-logo/w1.png') },
    { image: require('./../../images/home-11/client-logo/w2.png') },
    { image: require('./../../images/home-11/client-logo/w3.png') },
    { image: require('./../../images/home-11/client-logo/w4.png') },
]

class Coverflow extends React.Component {
    render() {
        return (
            <>
                <div className="section-full bg-gray p-t90 p-b50">
                
                    <div className="container">
                   <h2 style={ {textAlign: 'center', paddingBottom: '25px'}} >Our Concern</h2>
                        <div className="section-content client-logo2 ">
                            <div className="row justify-content-center">
                                
                                {logos.map((item, index) => (
                                    <div className="col-lg-3 col-md-4 col-sm-4 col-6" key={index}>
                                    <span className={(index === 0) ? "wt-img-effect client-logo2-media active" : "wt-img-effect client-logo2-media active"}>
                                            <img src={item.image.default} alt="" />
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Coverflow;